"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityImageViewer = exports.EntityImageViewerDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var types_1 = require("@shapeable/types");
var theme_1 = require("@shapeable/theme");
var image_viewer_1 = require("../elements/image-viewer");
var entity_title_1 = require("./entity-title");
var entity_type_icon_label_1 = require("./entity-type-icon-label");
exports.EntityImageViewerDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n    padding: ", ";\n    ", ";\n  "], ["\n    color: ", ";\n    padding: ", ";\n    ", ";\n  "])), theme_1.theme.COLOR('light'), theme_1.theme.UNIT(2), theme_1.theme.FILL('light'))
});
var CreditStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(image_viewer_1.ImageViewer)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Title: (0, styled_components_1.default)(entity_title_1.EntityTitle)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Credit: (0, styled_components_1.default)(entity_type_icon_label_1.EntityTypeIconLabel).attrs({
    entityTypeName: 'Person'
  })(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), CreditStyles)
};
var EntityImageViewer = function (props) {
  var className = props.className,
    entity = props.entity,
    children = props.children;
  var openGraph = entity === null || entity === void 0 ? void 0 : entity.openGraph;
  var image = entity.banner && entity.banner.image2x || (openGraph === null || openGraph === void 0 ? void 0 : openGraph.image);
  var description = entity.description || (openGraph === null || openGraph === void 0 ? void 0 : openGraph.description);
  return react_1.default.createElement(My.Container, {
    title: react_1.default.createElement(My.Title, {
      size: "medium",
      entity: entity
    }),
    image: image,
    className: className
  }, children || (0, types_1.isContentNode)(description) && description && description.text);
};
exports.EntityImageViewer = EntityImageViewer;
exports.EntityImageViewer.defaultProps = exports.EntityImageViewerDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;